import {ClassComponent, Vnode, VnodeDOM} from 'mithril';
import app from 'flarum/forum/app';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import classList from 'flarum/common/utils/classList';
import Picture from '../models/Picture';

const translationPrefix = 'kilowhat-cimaise.forum.editable-attribute.';

interface EditablePictureAttributeAttrs {
    picture: Picture
    attribute: KeyOfType<Picture, () => string>
    editable: boolean
    inputElement?: string
}

export default class EditablePictureAttribute implements ClassComponent<EditablePictureAttributeAttrs> {
    editing: boolean = false
    loading: boolean = false

    readView(value: any, attribute: string, editable: boolean) {
        if (this.loading) {
            return LoadingIndicator.component({size: 'tiny'});
        }

        if (value) {
            return value;
        }

        if (editable) {
            return m('span.PictureAttribute--placeholder', app.translator.trans(translationPrefix + attribute));
        }
    }

    view(vnode: Vnode<EditablePictureAttributeAttrs>) {
        const {
            picture,
            attribute,
            editable,
            inputElement,
        } = vnode.attrs;

        const element = inputElement || 'input';
        const value = picture[attribute]();

        return m('.PictureAttribute', {
            className: classList({
                editable,
                editing: this.editing
            }),
        }, this.editing ? m(element + '.js-input-field.PictureAttribute--field', {
            value: typeof value === 'undefined' ? '' : value,
            placeholder: app.translator.trans(translationPrefix + attribute),
            onblur: (event: Event) => {
                this.save((event.target as HTMLInputElement).value, picture, attribute);
            },
            onkeydown: (event: KeyboardEvent) => {
                event.redraw = false;

                // Enter should submit, while SHIFT+ENTER should allow newlines
                if (event.key === 'Enter' && !event.shiftKey) {
                    event.preventDefault();
                    this.save((event.target as HTMLInputElement).value, picture, attribute);
                }
            },
        }) : m('.PictureAttribute--field', {
            onclick: () => {
                if (!editable) {
                    return;
                }

                this.editing = true;

                setTimeout(() => {
                    const input = (vnode as any as VnodeDOM).dom.querySelector('.js-input-field') as HTMLInputElement | null;

                    if (input) {
                        input.focus();
                    }
                }, 50);

            },
        }, this.readView(value, attribute, editable)));
    }

    save(value: any, picture: Picture, attribute: KeyOfType<Picture, () => string>) {
        if (picture[attribute]() !== value) {
            this.loading = true;

            picture.save({
                [attribute]: value,
            }).then(() => {
                this.loading = false;
                m.redraw();
            }).catch(err => {
                this.loading = false;
                m.redraw();
                throw err;
            });
        }

        this.editing = false;
        m.redraw();
    }
}
